// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"41adc005","328":"81ea8358","474":"766917ed","480":"4ab72325","688":"e5f3120d","867":"bfc7d54c"}[chunkId] + ".chunk.js";
};